module.exports = __webpack_public_path__ + "img/physics_on.5505afde.svg";